import { render } from "./frequencyLimitCY.vue?vue&type=template&id=59ae8a17&scoped=true"
import script from "./frequencyLimitCY.vue?vue&type=script&lang=js"
export * from "./frequencyLimitCY.vue?vue&type=script&lang=js"

import "./frequencyLimitCY.vue?vue&type=style&index=0&id=59ae8a17&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-59ae8a17"

export default script